/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from 'react'
import { useGeneralApp } from '../../../hooks/useGeneralApp'
import './style.scss'

import Image from '../../../assets/FOBbundlesSMFSdfad-4.webp'

const merchandising = [
  {
    title: 'SO MUCH (FOR) STARDUST VINYL BLACK',
    price: 27.98,
    imgUrl: Image
  },
  {
    title: 'SO MUCH (FOR) STARDUST VINYL BLUE',
    price: 27.98,
    imgUrl: Image
  },
  {
    title: 'SO MUCH (FOR) STARDUST VINYL GREEN',
    price: 27.98,
    imgUrl: Image
  }
]

export const MerchandisingDetail = () => {
  const [count, setCount] = useState(0)

  return (
    <section className="container mt-2 mt-lg-4 mt-xl-5">
      <div className='merch-main'>
        <img className='merch-main-img' src = {merchandising[0].imgUrl}></img>
        <div className='merch-main-content'>
          <h6 className="h6">
            Camille Mandoki
          </h6>
          <h2 className="h1 pb-md-2 pb-lg-3">
            SO MUCH (FOR) STARDUST VINYL
          </h2>
          <h6 className="h6 pb-md-2 pb-lg-3">
            $27.98 USD
          </h6>
          <div className='merch-main-buttons'>
            <div className='merch-add-items'>
              <button
                onClick={() => setCount(count < 10 ? count + 1 : count)}
              >
                +
              </button>
              {count}
              <button
                onClick={() => setCount(count > 0 ? count - 1 : count)}
              >
                -
              </button>
            </div>
            <button className='btn btn-primary'>
              Comprar
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}
